/* UMDTHERETURN STORE — countdown card + product filter chips. */
(function () {
  var DAY_MS = 86400000;

  function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  }

  function countdownState(targetIso, now) {
    var target = new Date(targetIso);
    if (isNaN(target.getTime())) return null;
    var days = Math.round((startOfDay(target) - startOfDay(now)) / DAY_MS);
    if (days < 0) return { num: 'Thanks', unit: 'see you next year' };
    if (days === 0) return { num: 'Today', unit: 'homecoming is here' };
    return { num: String(days), unit: days === 1 ? 'day to go' : 'days to go' };
  }

  function initCountdown(card) {
    var state = countdownState(card.getAttribute('data-tr-countdown'), new Date());
    var num = card.querySelector('[data-tr-count-num]');
    var unit = card.querySelector('[data-tr-count-unit]');
    if (!state || !num || !unit) return;
    num.textContent = state.num;
    unit.textContent = state.unit;
    card.classList.toggle('tr-hero__count--word', isNaN(Number(state.num)));
  }

  function initFilters(section) {
    var chips = Array.prototype.slice.call(section.querySelectorAll('[data-tr-filter]'));
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-tr-type]'));

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var wanted = chip.getAttribute('data-tr-filter');
        chips.forEach(function (other) {
          other.setAttribute('aria-pressed', String(other === chip));
        });
        cards.forEach(function (card) {
          card.hidden = wanted !== 'all' && card.getAttribute('data-tr-type') !== wanted;
        });
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tr-countdown]'), initCountdown);
    Array.prototype.forEach.call(document.querySelectorAll('[data-tr-drop]'), initFilters);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
